// @ts-nocheck
const UsersSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default UsersSkeleton